module.exports = __webpack_public_path__ + "static/media/group-checklist.221da1c1.svg";